var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},[_c('v-prd-date-picker-field',{attrs:{"label":_vm.label,"rules":_vm.rules,"dense":""},model:{value:(_vm.compValue),callback:function ($$v) {_vm.compValue=$$v},expression:"compValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }